<template>
  <div
    :class="{
      modalOpennedDown:value && direction === 'down', modalDown:!value && direction === 'down',
      modalOpennedUp:value && direction === 'up', modalUp:!value && direction === 'up',
      modalOpennedLeft:value && direction === 'left', modalLeft:!value && direction === 'left',
      modalOpennedRight:value && direction === 'right', modalRight:!value && direction === 'right',

    }" style="position:fixed;z-index:19000;background-color:#ffffff;">
    <b-container class="content_slide_container">
      <b-row align-h="center" style="border-bottom:1px solid #F7F7F8;padding-bottom:8px;">
        <b-col style=" font-size: 18px; color: #757F8C; margin-top:20px;">
          <div @click="$emit('slideModalClose')" style="cursor:pointer;height:24px;width:32px;float:left;margin-right:10px;text-align:center;" :style="{color: getCssColor('primary_bt')}">
            <font-awesome-icon style="font-size:20px;"  :icon="['fal', 'chevron-' + directionChevron]"/>
          </div>
          <div class="text-center" style="padding-right:32px;" :style="{color: getCssColor('primary_bt')}">{{title}}</div>
        </b-col>
      </b-row>
      <b-row style="height:calc(100vh - 56px);">
        <b-col style="position:relative;height:100%;">
          <slot />
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
  import colors from '@/mixins/colors'

  export default {

    props: ['title', 'direction', 'value'], // direction up, down, left, right
    mixins: [colors],

    computed: {
      directionChevron () {
        if (this.direction === 'right'){
          return 'left'
        } else {
          return this.direction
        }
      }
    }

  }
</script>

<style lang="scss">

  @import "@/css/_variables.scss";

  .content_slide_container {
    max-width:$tablet;
    height:100vh;
    max-height:100vh;
  }
  .modalOpennedDown {
    height: 100vh;
    width:100vw;
    top:0vh;
    left:0;
    -webkit-transition: top 0.2s linear;
    -moz-transition: top 0.2s linear;
    -ms-transition: top 0.2s linear;
    -o-transition: top 0.2s linear;
    transition: top 0.2s linear;
  }

  .modalDown {
    height: 100vh;
    width: 100vw;
    top:130vh;
    left:0;
    -webkit-transition: top 0.2s linear;
    -moz-transition: top 0.2s linear;
    -ms-transition: top 0.2s linear;
    -o-transition: top 0.2s linear;
    transition: top 0.2s linear;
  }

  .modalOpennedUp {
    height: 100vh;
    width:100vw;
    top:0vh;
    left:0;
    -webkit-transition: top 0.2s linear;
    -moz-transition: top 0.2s linear;
    -ms-transition: top 0.2s linear;
    -o-transition: top 0.2s linear;
    transition: top 0.2s linear;
  }

  .modalUp {
    height: 100vh;
    width: 100vw;
    top: -130vh;
    left:0;
    -webkit-transition: top 0.2s linear;
    -moz-transition: top 0.2s linear;
    -ms-transition: top 0.2s linear;
    -o-transition: top 0.2s linear;
    transition: top 0.2s linear;
  }

  .modalOpennedLeft {
    height: 100vh;
    width:100vw;
    left:0;
    top:0;
    -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
    -ms-transition: left 0.2s linear;
    -o-transition: left 0.2s linear;
    transition: left 0.2s linear;
  }

  .modalLeft {
    height: 100vh;
    width: 100vw;
    left: -100vw;
    top:0;
    -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
    -ms-transition: left 0.2s linear;
    -o-transition: left 0.2s linear;
    transition: left 0.2s linear;
  }

  .modalOpennedRight {
    height: 100vh;
    width:100vw;
    left:0;
    top:0;
    -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
    -ms-transition: left 0.2s linear;
    -o-transition: left 0.2s linear;
    transition: left 0.2s linear;
  }

  .modalRight {
    height: 100vh;
    width: 100vw;
    left:100vw;
    top:0;
    -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
    -ms-transition: left 0.2s linear;
    -o-transition: left 0.2s linear;
    transition: left 0.2s linear;
  }
</style>
